import React from 'react';

import { PageLineContainer, Line } from './page-line.styles';

interface PageLineProps {
  title: string;
}

export const PageLine = ({ title }: PageLineProps) => (
  <PageLineContainer className="mt-5 mb-4">
    <div>
      <h4 className="mb-0">{title}</h4>
      <p className="mb-0"></p>
    </div>
    <Line />
  </PageLineContainer>
);
